import $ from 'jquery';
import 'bootstrap';
import enableNavigationBarFunctionality from './navigation-bar';
// wait until the DOM loads
$(() => {
    enableNavigationBarFunctionality();
});
